// extracted by css-extract-rspack-plugin
export default {"container":"container-i_lhBQ","tooltip":"tooltip-CdduoB","tooltipHeader":"tooltipHeader-SdaFh0","tooltipRow":"tooltipRow-Fa_FBk","tooltipSwatch":"tooltipSwatch-gM4sPl"};